import { useEffect, useState } from "react";

// Shared <img> wrapper implementing the "real image wins, fallback only on
// missing/broken" priority used across event & news cards and the Event
// Details page: try `src` (an uploaded/imported image) first, and only swap
// to `fallbackSrc` if there is no `src` at all or it fails to load. Keeping
// this in one place means every surface that renders an event image applies
// the exact same priority + fallback-swap behavior.
function FallbackImage({
  src,
  fallbackSrc,
  alt = "",
  className = "",
  placeholderClassName = "",
  placeholderLabel = "No image",
  ...imgProps
}) {
  const [current, setCurrent] = useState(src || fallbackSrc || "");

  useEffect(() => {
    setCurrent(src || fallbackSrc || "");
  }, [src, fallbackSrc]);

  if (!current) {
    return <div className={placeholderClassName || className}>{placeholderLabel}</div>;
  }

  return (
    <img
      src={current}
      alt={alt}
      loading="lazy"
      decoding="async"
      onError={() => {
        if (fallbackSrc && current !== fallbackSrc) setCurrent(fallbackSrc);
      }}
      className={className}
      {...imgProps}
    />
  );
}

export default FallbackImage;
